import MyEditBox from './edit-box.vue';

const TopicEditBox = {
  install: (Vue: any) => {
      Vue.component('TopicEditBox', MyEditBox);
  },
};

export default TopicEditBox;
